export const gtmTrackEvent = (props: { [key: string]: any }) => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer?.push({
    ...props,
  });
};
